import React, {Component,PropTypes} from 'react'
import {Link} from 'react-router'
class App extends Component {
  render() {
    return (
      <div >
        Dashboard
      </div>
    )
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js